import type { Role, UserPermissions, UserResponse, User } from '../../../shared/types';

/**
 * Derive internal role from API permission flags.
 * The API returns permissions instead of role strings to prevent information disclosure.
 */
export function deriveRoleFromPermissions(p: UserPermissions): Role {
  if (p.settings) return 'SUPER_ADMIN';
  if (p.admin) return 'ADMIN';
  if (p.manage) return 'COMPANY_MANAGER';
  return 'COMPANY_USER';
}

/**
 * Convert a UserResponse (from API, with permissions) to a User-like object (with role).
 * Used by admin pages that need the role for display/filtering.
 */
export function toUserWithRole(resp: UserResponse): User & { companyName?: string } {
  const { permissions, companyName, ...rest } = resp;
  return { ...rest, role: deriveRoleFromPermissions(permissions), companyName: companyName ?? undefined };
}
